import { MagicConfigMixin } from '@gig/magic-common';
import { __extends, __decorate, __metadata } from 'tslib';
import { Prop, Component, Mixins } from 'vue-property-decorator';

var MenuItemComponent = /** @class */ (function (_super) {
    __extends(MenuItemComponent, _super);
    function MenuItemComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(MenuItemComponent.prototype, "badgeText", {
        get: function () {
            if (typeof this.badge === 'boolean') {
                return '';
            }
            return this.badge;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], MenuItemComponent.prototype, "isActive", void 0);
    __decorate([
        Prop({
            validator: function (value) {
                return typeof value === 'boolean' || typeof value === 'number';
            },
        }),
        __metadata("design:type", Object)
    ], MenuItemComponent.prototype, "badge", void 0);
    __decorate([
        Prop({
            validator: function (value) {
                return (typeof value === 'number' ||
                    typeof value === 'string' ||
                    typeof value === 'object');
            },
        }),
        __metadata("design:type", Object)
    ], MenuItemComponent.prototype, "link", void 0);
    MenuItemComponent = __decorate([
        Component({
            name: 'ui-menu-item',
        })
    ], MenuItemComponent);
    return MenuItemComponent;
}(Mixins(MagicConfigMixin)));

export default MenuItemComponent;
